import { Fragment } from "react";
import EmptyData from "../../../../../../Component/Elements/EmptyData/EmptyData";
import Text from "../../../../../../Component/Elements/Text/Text";
import { Delivery_Address_data_Interface, ProductDetail_SelectInformationDate_Address_Interface } from "../../../../static/interface/ProductDetail.interface";
import DeliveryAddressItem from "../DeliveryAddressItem/DeliveryAddressItem";
import CSS from "./static/css/DeliveryAddressList.module.css";
import Hr from "../../../../../../Component/Elements/Hr/Hr";

const DeliveryAddressList = (
    {
        addressList,
        applyAddressHandler,
        product_qty,
    }:{
        addressList: Delivery_Address_data_Interface[];
        applyAddressHandler: (data: ProductDetail_SelectInformationDate_Address_Interface) => void;
        product_qty: number;
    }
) => {
    return (
        <div className={CSS.l_DeliveryAddressList_main}>
            <Text
                size={"size6"}
                bold={true}
            >
                사용한 배송지 목록
            </Text>

            <div>
                {
                    addressList.length > 0
                    ?   addressList.map((item, index) => {
                            const m_data: ProductDetail_SelectInformationDate_Address_Interface = {
                                ...item,
                                product_qty: product_qty,
                            }

                            return (
                                <Fragment key={index}>
                                    <DeliveryAddressItem 
                                        addr={item.addr}
                                        addr_detail={item.addr_detail}
                                        zip_code={item.zip_code}
                                        recipient_name={item.recipient_name}
                                        recipient_phone={item.recipient_phone}
                                        selectOnClickHandler={applyAddressHandler.bind(null, m_data)}
                                    />

                                    {
                                        addressList.length > index + 1
                                        &&  <Hr />
                                    }
                                </Fragment>
                            )
                        })
                    :   <EmptyData />
                }
            </div>
        </div>
    )
}

export default DeliveryAddressList;